<template>
    <welcome-box>
        <password-reset
            :hide-link="true"
        >
            <template v-slot:title>
                Set Your Password
            </template>
            <template v-slot:button-label>
                Set Password
            </template>
        </password-reset>
    </welcome-box>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBoxOld.vue';
import PasswordReset from '@/components/PasswordReset/PasswordReset.vue';

export default {
    components: {
        WelcomeBox,
        PasswordReset,
    },
};
</script>
